import { createContext } from "react";
import useLocalStorageState from "../hooks/useLocalStorageState";

export const GuidelinesSelectedCategoryContext = createContext();

const GuidelinesProvider = ({ children }) => {
  const [guide_selectedCategoryName, guide_setSelectedCategoryName] =
    useLocalStorageState("guide_selectedCategoryName", "");
  const [guide_selectedSubCategoryName, guide_setSelectedSubCategoryName] =
    useLocalStorageState("guide_selectedSubCategoryName", "");
  const [guide_selectedCategoryId, guide_setSelectedCategoryId] =
    useLocalStorageState("guide_selectedCategoryId", "");
  const [guide_selectedSubCategoryId, guide_setSelectedSubCategoryId] =
    useLocalStorageState("guide_selectedSubCategoryId", "");
  const [guide_selectedClientId, guide_setSelectedClientId] =
    useLocalStorageState("guide_selectedClientId", null);
  const [guide_selectedClientName, guide_setSelectedClientName] =
    useLocalStorageState("guide_selectedClientName", "Default");
  const [guide_selectedGuidelLineId, guide_setSelectedGuidelLineId] =
    useLocalStorageState("guide_selectedGuidelineId", "");
  const [guide_selectedMarketPlaceIds, guide_setSelectedMarketPlaceIds] =
    useLocalStorageState("guide_selectedMarketPlaceIds", []);
  const [guide_selectedMarketPlaceId, guide_setSelectedMarketPlaceId] =
    useLocalStorageState("guide_selectedMarketPlaceId", []);
  const [guide_selectedMarketPlaceName, guide_setSelectedMarketPlaceName] =
    useLocalStorageState("guide_selectedMarketPlaceName", []);
  const [guide_selectedRequestId, guide_setSelectedRequestId] =
    useLocalStorageState("guide_selectedRequestId", "");
  const [guide_selectedMarkedReview, guide_setSelectedMarkedReview] =
    useLocalStorageState("guide_selectedMarkedReview", "");

  return (
    <GuidelinesSelectedCategoryContext.Provider
      value={{
        guide_selectedCategoryName,
        guide_setSelectedCategoryName,
        guide_selectedSubCategoryName,
        guide_setSelectedSubCategoryName,
        guide_selectedCategoryId,
        guide_setSelectedCategoryId,
        guide_selectedSubCategoryId,
        guide_setSelectedSubCategoryId,
        guide_selectedClientId,
        guide_setSelectedClientId,
        guide_setSelectedClientName,
        guide_selectedClientName,
        guide_selectedGuidelLineId,
        guide_setSelectedGuidelLineId,
        guide_selectedMarketPlaceIds,
        guide_setSelectedMarketPlaceIds,
        guide_selectedRequestId,
        guide_setSelectedRequestId,
        guide_selectedMarkedReview,
        guide_setSelectedMarkedReview,
        guide_selectedMarketPlaceId,
        guide_setSelectedMarketPlaceId,
        guide_selectedMarketPlaceName,
        guide_setSelectedMarketPlaceName,
      }}
    >
      {children}
    </GuidelinesSelectedCategoryContext.Provider>
  );
};

export default GuidelinesProvider;
